import React, { useContext, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { Translate, Localize, getLocale, setLocale } from "react-i18nify";

import StepperButton from "./StepperButton_V";

import { kioskstyles } from "./../../../../kioskstyles";

import { WORKFLOW_MODES } from "../../../../constants";

import { StepConnector } from "@mui/material";

import { useTheme, createTheme, ThemeProvider } from "@mui/material/styles";
import { colors } from "@mui/material";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = mainColor => augmentColor({ color: { main: mainColor } });

// props has activeStep
export default function KioskStepper({
  activeStep,
  workflowmode,
  backUrl,
  backOverwriteFunc,
  getKioskConfiguration
}) {
  const navigate = useNavigate();

  const { getKioskTheme } = useContext(SocketIOContext);

  const theme = useTheme();
  const kioskTheme = getKioskTheme();

  const [steps, setSteps] = useState(["", "", ""]);

  //workflowmode should work as well, can refactor to this if need
  // useEffect(() => {
  //   console.log("KioskStepper_V workflow UPDATED!", workflowmode);
  //   if (workflowmode === "bag") {
  //     setSteps(["", "", ""]);
  //     console.log(
  //       "KioskStepper_V workflow DEBUG bag thus SINGLE now",
  //       workflowmode,
  //       "bag"
  //     );
  //   } else {
  //     setSteps(["", "", "", ""]);
  //     console.log(
  //       "KioskStepper_V workflow DEBUG NOT single now",
  //       workflowmode,
  //       "bag"
  //     );
  //   }
  // }, [workflowmode]);

  useEffect(() => {
    const kioskconfig = getKioskConfiguration();
    if (kioskconfig == null) {
      return;
    }

    let kc_workflowmode = kioskconfig.workflowMode;

    //console.log("kc_workflowmode", kc_workflowmode);

    switch (kc_workflowmode) {
      case WORKFLOW_MODES.BAG_ONLY_WITH_AUTH:
      case WORKFLOW_MODES.BAG_ONLY:
        setSteps(["", "", ""]);
        break;
      default:
        setSteps(["", "", "", ""]);
        break;
    }
  }, []);

  const vtheme = createTheme(theme, {
    primary: createColor("#000000"),
    secondary: colors.pink,
    components: {
      MuiButton: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              minWidth: "0px" //Fix for scaling button on higher res
            }
          })
        }
      },
      // MuiButtonBase: {
      //   styleOverrides: {
      //     root: ({ ownerState }) => ({
      //       ...{
      //         backgroundColor: ""
      //       }
      //     })
      //   }
      // },
      MuiStepIcon: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              width: "2.2vh",
              height: "2.2vh",
              //border: "1px solid #444444",
              border: "0.1vh solid black",
              borderRadius: "50%",
              //opacity: 0.5,
              //backgroundColor: "white",
              color: "rgba(0,0,0,0)",
              "&.Mui-active": {
                //border: "1px solid black",
                border: "0px solid black",
                opacity: 1,
                width: "2.5vh", //Maybe it should be 2.2
                height: "2.5vh", //Maybe it should be 2.2
                color: kioskTheme.stepperStepBGColor, //Stepper BG Color
                // color: "pink", //Stepper BG Color
                "& .MuiStepIcon-text": {
                  //fill: kioskTheme.stepperStepTextColor
                  //fill: "#ffffff"
                  fill: "#ffffff"
                }
              },
              "&.Mui-completed": {
                //border: "1px solid black",
                color: kioskTheme.stepperStepBGColor, //Stepper BG Color
                border: "0px solid black",
                opacity: 1,
                width: "2.5vh", //Maybe it should be 2.2
                height: "2.5vh", //Maybe it should be 2.2
                backgroundColor: "white"
                //backgroundColor: kioskTheme.stepperStepTextColor
              }
            }
          }),
          text: ({ ownerState }) => ({
            ...{
              fill: "black" //Text color
              // //fontSize: "2vh"
              // "&.Mui-active": {
              //   fill: "white"
              // }
            }
          })
        }
      },
      MuiStepConnector: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              "&.Mui-disabled": {
                opacity: 0
              }
            }
          }),
          line: ({ ownerState }) => ({
            ...{
              borderColor: "black",
              "&.Mui-disabled": {
                opacity: 0
              }
            }
          })
        }
      },
      MuiStep: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              paddingLeft: "2.2vw"
            }
          })
        }
      },
      MuiStepButton: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              //margin: 0,
              //padding: 0,
              //top: "-0.5vh"
              top: "-0.2rem" //Seems to actually scale???
            }
          })
        }
      },
      MuiStepLabel: {
        styleOverrides: {
          iconContainer: ({ ownerState }) => ({
            ...{
              paddingRight: "1.25vh"
            }
          })
        }
      }
    }
  });

  const pressBack = () => {
    //console.log(
    //  "[pressBack] backUrl backOverwriteFunc",
    //  backUrl,
    //  backOverwriteFunc
    //);
    if (backUrl !== undefined) {
      navigate(backUrl);
    }

    if (backOverwriteFunc !== undefined) {
      backOverwriteFunc();
    }
  };

  const pressEnd = () => {
    const kiosktheme = getKioskTheme();
    if (kiosktheme.bilingual) {
      setLocale("fr");
    }

    navigate("/language");
  };

  return (
    <div
      style={
        {
          //maxWidth: "490px", //Same as blackCornedDiv
          //width: "41vw" //TODO: use minWidth, if mobile
        }
      }
    >
      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
      >
        <Button
          variant="contained"
          disabled={backUrl == undefined && backOverwriteFunc == undefined}
          onClick={pressBack}
          style={{
            borderRadius: "1vi",
            textTransform: "capitalize",
            //marginRight: "1.25vw",
            padding: "0.5vw 2vw 0.5vw 1.5vw",
            backgroundColor: kioskTheme.buttonsBGColor,
            color: kioskTheme.buttonsTextColor,
            height: "3.9vh",
            width: "19vw",
            minWidth: "0vh"
          }}
        >
          <KeyboardBackspaceIcon
            style={{ marginRight: "1.9vw", fontSize: "2.3vh" }}
          />
          {/* &nbsp; &nbsp; */}
          <span class="fontSecondaryText" style={{ fontSize: "1.3vh" }}>
            <Translate value="application.theme.footerBackText" />
          </span>
        </Button>
        <ThemeProvider theme={vtheme}>
          <Stepper
            activeStep={activeStep}
            style={{
              width: "32vw",
              paddingLeft: "6.5vw",
              paddingRight: "6.5vw"
            }}
            connector={<StepConnector />}
          >
            {steps.map((label, index) => (
              <Step
                key={index}
                style={{ paddingLeft: "2.2vw", paddingRight: "0vw" }}
              >
                {/* <StepButton
                color="inherit"
                style={{ height: "1.9vh", width: "1.9vh" }}
              >
                {label}
              </StepButton> */}
                <StepperButton
                  color="inherit"
                  style={{ height: "1.9vh", width: "1.9vh" }}
                >
                  {label}
                </StepperButton>
                {/* <div color="inherit" style={{ height: "1.9vh", width: "1.9vh" }}>
                <span>{label}</span>
              </div> */}
              </Step>
            ))}
          </Stepper>
        </ThemeProvider>
        <Button
          variant="contained"
          onClick={pressEnd}
          style={{
            borderRadius: "1vi",
            textTransform: "capitalize",
            padding: "0.5vw 2vw 0.5vw 1.5vw",
            backgroundColor: kioskTheme.buttonsBGColor,
            color: kioskTheme.buttonsTextColor,
            height: "3.9vh",
            width: "19vw",
            minWidth: "0vh"
          }}
        >
          <CancelIcon style={{ marginRight: "1.9vw", fontSize: "2.3vh" }} />
          <span class="fontSecondaryText" style={{ fontSize: "1.3vh" }}>
            <Translate value="application.theme.footerEndText" />
          </span>
        </Button>
      </Box>
    </div>
  );
}
